/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type chat_viewer$ref = any;
export type chat_viewer = {
    readonly vipChatEmail: ReadonlyArray<{
        readonly userDataB: ReadonlyArray<{
            readonly email?: string | null;
        } | null> | null;
    } | null> | null;
    readonly tradeChatEmail: ReadonlyArray<{
        readonly userDataB: ReadonlyArray<{
            readonly email?: string | null;
        } | null> | null;
    } | null> | null;
    readonly allTransactions: {
        readonly totalResults: number | null;
    } | null;
    readonly initiatedTransactions: {
        readonly totalResults: number | null;
    } | null;
    readonly submittedTransactions: {
        readonly totalResults: number | null;
    } | null;
    readonly confirmedTransactions: {
        readonly totalResults: number | null;
    } | null;
    readonly " $refType": chat_viewer$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  }
],
v2 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userIds"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v4 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalResults",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "chat_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "vipChatEmail",
      "name": "userRelationships",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "VIP"
        },
        (v0/*: any*/)
      ],
      "concreteType": "UserRelationship",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "userDataB",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "VipRepData",
              "selections": (v1/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "tradeChatEmail",
      "name": "userRelationships",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "TRADE"
        },
        (v0/*: any*/)
      ],
      "concreteType": "UserRelationship",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "userDataB",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "TradeRepData",
              "selections": (v1/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "allTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.initiated"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.submitted"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "confirmedTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "sort",
          "value": "createdDate asc"
        },
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.confirmed"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    }
  ]
};
})();
(node as any).hash = 'b6f7241498eb48f30528a3ef27a80459';
export default node;
